import React from 'react';

import Config from './Config';
import Name from './Name';

const RulesFormStateless = (props) => {
  const { onBlur: onBlurProp, onChange, values } = props;

  // autogenerate rule name if it is empty
  const onBlur = ({ target: { name } }) => {
    onBlurProp({ target: { name } });

    if (name === 'root.config.services' || name === 'root.config.projects') {
      const services = values.config && values.config.services;
      const projects = values.config && values.config.projects;
      if (values.name || !Array.isArray(services) || !Array.isArray(projects) || services.length === 0 || projects.length === 0) return;

      onChange({
        target: {
          name: 'root.name',
          value: `${services.map(s => s.label).join(',')} <---> ${projects.map(s => s.label).join(',')}`
        }
      });
    }
  };

  return (
    <div>
      <Name {...props}/>
      <Config {...{ ...props, onBlur }}/>
    </div>
  );
};

export default RulesFormStateless;
